import React, { createContext, useContext, useState } from 'react';

// Define tab types
export type TabType = 'classrooms' | 'staff' | 'details' | 'historical';

interface NavigationContextType {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}

// Create context with default values
const NavigationContext = createContext<NavigationContextType>({
  activeTab: 'classrooms',
  setActiveTab: () => {},
});

// Custom hook to use the navigation context
export const useNavigation = () => useContext(NavigationContext);

export default NavigationContext;
